<template>
  <div class="background-gray">
    <v-container class>
      <v-row>
        <v-col cols="12" lg="6" class="title">Firmas de Conformidad</v-col>
        <v-col cols="12">
          <v-card outlined class="background-gray">
            <div class="font-weight-light absolute-text-title caption">
              Transportista que entrega
            </div>
            <v-list-item v-if="signChecklistDeliverer">
              <v-list-item-content class="pt-4">
                <div class="mb-4">{{ signChecklistDeliverer.name }}</div>
                <div class="sign-background-white pt-2 pb-2 mb-2">
                  <v-img
                    :src="validSrcImage(signChecklistDeliverer.signImage)"
                    aspect-ratio="1.7"
                    height="70"
                    contain
                    @click="downloadImage(signChecklistDeliverer.signImage)"
                  ></v-img>
                </div>
                <div
                  v-if="
                    signChecklistDeliverer.identificationFront &&
                      signChecklistDeliverer.identificationBack
                  "
                  class="sign-background-white pt-2 pb-2"
                >
                  <v-img
                    :src="
                      validSrcImage(signChecklistDeliverer.identificationFront)
                    "
                    aspect-ratio="1.7"
                    height="140"
                    contain
                    class="mb-4"
                    @click="
                      downloadImage(signChecklistDeliverer.identificationFront)
                    "
                  ></v-img>
                  <v-img
                    :src="
                      validSrcImage(signChecklistDeliverer.identificationBack)
                    "
                    aspect-ratio="1.7"
                    height="140"
                    contain
                    @click="
                      downloadImage(signChecklistDeliverer.identificationBack)
                    "
                  ></v-img>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card outlined class="background-gray">
            <div class="font-weight-light absolute-text-title caption">
              Persona que recibe
            </div>
            <v-list-item v-if="signChecklistReceiver">
              <v-list-item-content class="pt-4">
                <div class="mb-4">{{ signChecklistReceiver.name }}</div>
                <div class="sign-background-white pt-2 pb-2 mb-2">
                  <v-img
                    :src="validSrcImage(signChecklistReceiver.signImage)"
                    aspect-ratio="1.7"
                    height="70"
                    contain
                    @click="downloadImage(signChecklistReceiver.signImage)"
                  ></v-img>
                </div>
                <div
                  v-if="
                    signChecklistReceiver.identificationFront &&
                      signChecklistReceiver.identificationBack
                  "
                  class="sign-background-white pt-2 pb-2"
                >
                  <v-img
                    :src="
                      validSrcImage(signChecklistReceiver.identificationFront)
                    "
                    aspect-ratio="1.7"
                    height="140"
                    contain
                    class="mb-4"
                    @click="
                      downloadImage(signChecklistReceiver.identificationFront)
                    "
                  ></v-img>
                  <v-img
                    :src="
                      validSrcImage(signChecklistReceiver.identificationBack)
                    "
                    aspect-ratio="1.7"
                    height="140"
                    contain
                    @click="
                      downloadImage(signChecklistReceiver.identificationBack)
                    "
                  ></v-img>
                </div>
                <div
                  v-if="
                    signChecklistReceiver.orderFront &&
                      signChecklistReceiver.orderBack
                  "
                  class="sign-background-white pt-2 pb-2"
                >
                  <v-img
                    :src="validSrcImage(signChecklistReceiver.orderFront)"
                    aspect-ratio="1.7"
                    height="140"
                    contain
                    class="mb-4"
                    @click="downloadImage(signChecklistReceiver.orderFront)"
                  ></v-img>
                  <v-img
                    :src="validSrcImage(signChecklistReceiver.orderBack)"
                    @click="downloadImage(signChecklistReceiver.orderBack)"
                    aspect-ratio="1.7"
                    height="140"
                    contain
                  ></v-img>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["isEditChecklist"],
  methods: {
    validSrcImage(url) {
      if (!this.isEditChecklist) {
        if (!url) return require("@/assets/logo.png");
        if (url.includes("https")) return url;
        return require("@/assets/logo.png");
      }
      return url;
    },
    downloadImage(url) {
      window.open(url, "_blank");
    }
  },
  computed: {
    ...mapState("checklist", [
      "signChecklistDeliverer",
      "signChecklistReceiver"
    ])
  }
};
</script>
<style>
.background-gray {
  background: #f6f6f6 !important;
}
.absolute-text-title {
  position: absolute;
  top: -12px;
  background: #f6f6f6;
  padding: 0 5px 0 5px;
  left: 10px;
}
.sign-background-white {
  background-color: white;
}
</style>
